import React, { PureComponent, ReactNode } from 'react';
import { IsServerSideRendering } from '../services';
import RegisterBetaExperiment from './RegisterBetaExperiment';
import { Experiments, ServerCookies } from '../SharedTypes';
import ExperimentContext from '../Experiment/ExperimentContext';

type ownProps = typeof BetaExperiment.defaultProps & {
  name: string;
  identifier: string;
  environment: string;
  defaultBucket: string;
  cacheMinutes: number;
  renderDefaultOnServer?: boolean;
  loading?: ReactNode | string;
  loadingDelay?: number;
  serverCookies?: ServerCookies;
  updateExperiment?: Function;
  experiments?: Experiments;
  killSwitch?: string;
  betaExperimentType: string;
};

type ownState = {
  isPastDelay: boolean;
};

class BetaExperiment extends PureComponent<ownProps, ownState> {
  static defaultProps = {
    experiments: {},
    defaultBucket: 'control',
    renderDefaultOnServer: true,
    serverCookies: {},
    updateExperiment: () => {},
    loadingDelay: 0
  };

  delaying;

  state = {
    isPastDelay: false
  }

  componentDidMount() {
    const { updateExperiment, loadingDelay } = this.props;

    if (typeof loadingDelay === 'number') {
      if (loadingDelay === 0) {
        this.updateState({ isPastDelay: true });
      } else {
        this.delaying = setTimeout(() => {
          this.updateState({ isPastDelay: true });
        }, loadingDelay);
      }
    }
    RegisterBetaExperiment(this.props, updateExperiment);
  }

  componentWillUnmount() {
    clearTimeout(this.delaying);
  }

  updateState = state => this.setState(state);

  render() {
    const {
      loading,
      children,
      name,
      experiments,
      defaultBucket,
      renderDefaultOnServer,
      serverCookies,
      updateExperiment
    } = this.props;
    const { isPastDelay } = this.state;
    const { isLoading = true } = experiments[name] || {};
    const showLoading = !!(isLoading && loading && isPastDelay);

    if (showLoading && typeof loading === 'string' && experiments[name]) {
      experiments[name].assignedBucket = loading;
      experiments[name].isLoading = false;
    }

    if (IsServerSideRendering() && !experiments[name]) {
      const assignedBucket = serverCookies[name] || (renderDefaultOnServer ? defaultBucket : '');
      experiments[name] = { assignedBucket };
    }

    const providerContext = {
      experiments,
      currentExperiment: name,
      updateExperiment
    };

    return (
      <ExperimentContext.Provider value={providerContext}>
        {showLoading && typeof loading !== 'string' ?
          loading
          : (
            <>{children}</>
          )}
      </ExperimentContext.Provider>
    );
  }
};

export default BetaExperiment;
